export default __webpack_public_path__ + "static/media/cif-vc.ab36204c.svg";